(function ($) {

    function mobileTableScroll() {
        if ($(window).width() < 840) {
            $(".mod-table--scroll").parent().closest(".mod-flex").css("display", "block");
        }
    }

    mobileTableScroll();

    $(window).resize(function () {
        mobileTableScroll();
    });

})(window.jQuery);